import { io, Socket } from 'socket.io-client';
import type { ClientServerEvents } from '@scan2eat/shared';
import { SOCKET_NAMESPACES } from '@scan2eat/shared';

export type ClientSocket = Socket<ClientServerEvents>;

let socket: ClientSocket | null = null;

export function connectClientSocket(sessionToken: string): ClientSocket {
  if (socket?.connected) return socket;

  const baseUrl = import.meta.env.VITE_API_URL?.replace(/\/api\/?$/, '') ?? '';
  socket = io(`${baseUrl}${SOCKET_NAMESPACES.CLIENT}`, {
    auth: { sessionToken },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionDelay: 500,
    reconnectionDelayMax: 5000,
    reconnectionAttempts: Infinity,
    timeout: 10000,
  });

  return socket;
}

export function disconnectClientSocket(): void {
  if (socket) {
    socket.disconnect();
    socket = null;
  }
}
